import React, {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useEffect,
  useState,
} from 'react';
import { AuthUser } from '../interfaces';
import { loadUserFromLocalStorage } from '../utils/localstorage';
import { setToken } from '../api';

interface AppContextProps {
  user: AuthUser | null;
  setUser: Dispatch<SetStateAction<AuthUser | null>>;
}

export const AppContext = createContext<AppContextProps>({
  user: null,
  setUser: () => {},
});

export const AppProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUser] = useState<AuthUser | null>(null);

  //TODO: Implement auth logic using an auth hook and react query or start using a an auth library like auth0
  useEffect(() => {
    const load = async () => {
      try {
        const u = await loadUserFromLocalStorage();
        if (u) {
          setUser(u);
          setToken(u.token);
        }
      } catch (error) {
        console.error('Failed to load user:', error);
      }
    };
    void load();
  }, []);

  const values = {
    user,
    setUser,
  };

  return <AppContext.Provider value={values}>{children}</AppContext.Provider>;
};
